import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl, formatQuarter } from "@/lib/api";
import { Play, Clock } from "lucide-react";
import { Overline } from "@/components/site/Primitives";

export function VideoCard({ video, className = "" }) {
  return (
    <Link to={`/videos/${video.slug}`} className={`group block ${className}`} data-testid={`video-card-${video.slug}`}>
      <div className="relative aspect-video overflow-hidden bg-ink">
        {video.thumbnail ? (
          <img
            src={mediaUrl(video.thumbnail)}
            alt={video.title}
            loading="lazy"
            className="h-full w-full object-cover opacity-85 transition-all duration-500 ease-out group-hover:scale-105 group-hover:opacity-100"
          />
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-ink to-steel-600" />
        )}
        <span className="absolute inset-0 bg-ink/25" />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full border border-cream-100/40 bg-ink/40 backdrop-blur-md transition-transform duration-300 group-hover:scale-110">
            <Play className="ml-0.5 h-6 w-6 fill-gold-400 text-gold-400" />
          </span>
        </span>
        {video.duration && (
          <span className="absolute bottom-3 right-3 flex items-center gap-1 bg-ink/70 px-2 py-1 font-sans text-xs text-cream-100">
            <Clock className="h-3 w-3" /> {video.duration}
          </span>
        )}
      </div>
      <div className="pt-4">
        {video.topic && <Overline>{video.topic}</Overline>}
        <h3 className="mt-2 font-serif text-xl font-normal leading-snug text-ink transition-colors group-hover:text-gold-600">
          {video.title}
        </h3>
        {video.published_at && (
          <p className="mt-2 font-sans text-xs tracking-wide text-steel-400">{formatQuarter(video.published_at)}</p>
        )}
      </div>
    </Link>
  );
}
